module.exports = __webpack_public_path__ + "img/calendar.2f967b4c.svg";